// Feature for adding an item to the cart based on parameters in the URL functionality

/******************************************************************
START Swappable constant variables depending on product
*******************************************************************/
const PROMO_URL_STRING = ["FREE_AIRTAG", "free_airtag", "free-airtag", "FREE-AIRTAG"];
const US_PRODUCT_VARIANT_ID = 39912097415242;
const AU_PRODUCT_VARIANT_ID = 39892345913477;
const CA_PRODUCT_VARIANT_ID = 40685895581832;
const EU_PRODUCT_VARIANT_ID = 42211012739210;
const UK_PRODUCT_VARIANT_ID = 40782973042827; 
/******************************************************************
END Swappable constant variables depending on product
*******************************************************************/

// Variable needs to be different from "currentURL"
let airtagURL = window.location.href;
// Variable needs to be different from "item_to_add"
let airtag_item_to_add;

//set to run on all stores
if (airtagURL.includes("/")) {
  if (airtagURL.includes("ridge.com")) {
    airtag_item_to_add = US_PRODUCT_VARIANT_ID;
    console.log("This is US");
  }
  if (airtagURL.includes("ridgewallet.co.uk")) {
    airtag_item_to_add = UK_PRODUCT_VARIANT_ID;
    console.log("This is UK");
  }
  if (airtagURL.includes("ridgewallet.eu")) {
    airtag_item_to_add = EU_PRODUCT_VARIANT_ID;
    console.log("This is EU");
  }
  if (airtagURL.includes("ridgewallet.ca")) {
    airtag_item_to_add = CA_PRODUCT_VARIANT_ID;
    console.log("This is CA");
  }
  if (airtagURL.includes("ridgeau.com")) {
    airtag_item_to_add = AU_PRODUCT_VARIANT_ID;
    console.log("This is AU");
  }

  /*
  This is a remnant feature where Wunderkind, a third-party modal, was included in the free_product
  promotion.

  Wunderkind added a custom class in their modal's button, where we added the free_product in the customer's 
  cart when the customer filled out the form.
  */
  document.arrive(".ridge-activate-offer-button", function () {
    const offerBtn = document.querySelector(".ridge-activate-offer-button");
    offerBtn.addEventListener("click", freeProductFromModal);
  });

  // ADD TRAY ON CLICK + VALID EMAIL
  function freeProductFromModal() {
    // Checking for valid email format
    const emailInputVal = $(".ridge-activate-offer-input").val();
    const emailValidator = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const validEmail = emailValidator.test(String(emailInputVal).toLowerCase()); // boolean

    if (validEmail) {
      addFreeTrayAJAX();
    }
  }

  // ADD FREE PRODUCT WHEN PAGE FINDS the PROMO_URL_STRING (defined at top of this file) IN URL:
  if (PROMO_URL_STRING.some(v => airtagURL.includes(v))) {
      addFreeProductAJAX()
  }

  function addFreeProductAJAX() {
    $.ajax({
      url: "/cart.js",
      dataType: "json",
      type: "GET",
      cache: false,
      success: function (cart) {
        let freeProductExistsInCart = true;

        if (cart.item_count < 1) {
          freeProductExistsInCart = false;
        }
        // LOOP THRU EACH ITEM TO MAKE SURE NONE ARE THE SPECIFIED FREE PRODUCT
        if (cart.items.length > 0) {
          cart.items.forEach((item) => {
            if (item.variant_id === airtag_item_to_add) {
              freeProductExistsInCart = true;
            } else {
              freeProductExistsInCart = false;
            }
          });
        }

        if (!freeProductExistsInCart) {
          // add to cart API
          let freeProductData = {
            items: [
              {
                id: airtag_item_to_add,
                quantity: 1,
              },
            ],
          };

          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            dataType: "JSON",
            data: freeProductData,
            success: function (cart) {
              $.ajax({
                url: "/cart.js",
                dataType: "json",
                cache: false,
                success: function (cart) {
                  refreshMiniCart(cart);
                },
              });
            },
            error: function (err) {
              console.log("free-airtag.js error with adding free product: ", err);
            },
          });
        }
      },
      error: function (err) {
        console.log("free-airtag.js error with fetching cart: ", err);
      },
    });
  }
}
/******************************************************************
 End feature for adding an item to the cart based on parameters in the URL functionality 
 *******************************************************************/

/******************************************************************
Start feature to remove cavity tray from upsell when it's added to the cart.
 *******************************************************************/

/*
The window.location.reload() is necessary so that
cart-upsell.liquid can run correctly - because it depends on the
Free Cavity Tray to be in the cart to run the logic of NOT including the original cavity tray in the upsell. 

cart-upsell.liquid will prevent cavity tray from showing up if cavity tray is in cart. 
a click event will refresh the browser so that cart-upsell.liquid sees the free cavity tray in the cart.

On FIRST initial load of the website, the Free Cavity Tray isn't in the cart, so
cart-upsell.liquid doesn't prevent the original cavity tray from showing in the upsell. 
*/

// No thanks button
document.arrive("#bx-element-1421473-qGMCUcK > button", function () {
  this.addEventListener("click", function () {
    window.location.reload();
  });
});
// Mobile X close button
document.arrive("#bx-close-inside-1421473 > svg", function () {
  this.addEventListener("click", function () {
    window.location.reload();
  });
});
// Last popup's Continue Shopping button
document.arrive("#bx-element-1421473-pdEAJP8 > button", function () {
  this.addEventListener("click", function () {
    window.location.reload();
  });
});
// Last popup's X close button
document.arrive("#bx-close-inside-1421473 > svg", function () {
  this.addEventListener("click", function () {
    window.location.reload();
  });
});
